var _path, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0254 1L20.027 9.00154V22.2041C20.027 23.7508 18.7731 25.0046 17.2264 25.0046H2.82367C1.27698 25.0046 0.0231323 23.7508 0.0231323 22.2041V3.80054C0.0231323 2.25384 1.27698 1 2.82367 1H12.0254Z",
    fill: "#67787E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.44183 15.9117C9.5861 16.1047 9.77016 16.2645 9.98153 16.3801C10.1929 16.4956 10.4266 16.5644 10.6669 16.5816C10.9071 16.5988 11.1482 16.5641 11.3739 16.4799C11.5996 16.3956 11.8045 16.2638 11.9748 16.0932L12.9826 15.0845C13.2886 14.7674 13.4579 14.3427 13.454 13.9019C13.4502 13.4611 13.2736 13.0394 12.9621 12.7277C12.6507 12.4159 12.2294 12.2391 11.789 12.2353C11.3486 12.2315 10.9243 12.4009 10.6075 12.7072L10.0297 13.2822",
    stroke: "#F4F5F8",
    strokeWidth: 0.822201,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7859 15.2392C10.6416 15.0461 10.4576 14.8864 10.2462 14.7708C10.0348 14.6552 9.80108 14.5865 9.56084 14.5692C9.3206 14.552 9.07947 14.5867 8.8538 14.671C8.62813 14.7552 8.42321 14.8871 8.25293 15.0576L7.24513 16.0663C6.93916 16.3834 6.76986 16.8081 6.77368 17.249C6.77751 17.6898 6.95416 18.1115 7.26559 18.4232C7.57701 18.7349 7.99829 18.9117 8.4387 18.9155C8.8791 18.9194 9.30339 18.7499 9.62018 18.4437L10.1946 17.8687",
    stroke: "#F4F5F8",
    strokeWidth: 0.822201,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.027 9.00159H14.9674C13.4207 9.00159 12.0254 7.60629 12.0254 6.0596V1.00005L20.027 9.00159Z",
    fill: "white",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 11.6254,
    y: 0.199846,
    width: 8.80169,
    height: 8.80169,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.400077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.200038
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0909637 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.22201,
    height: 8.22201,
    fill: "white",
    transform: "translate(6.00281 11.4642)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLink);
export default __webpack_public_path__ + "static/media/file-link.4e115374745f6576c8a9c9fc1b7ebb62.svg";
export { ForwardRef as ReactComponent };